import { all } from 'redux-saga/effects'
import watchSignageScreenCreateRequest from './watchSignageScreenCreateRequest'
import watchSignageScreenUpdateRequest from './watchSignageScreenUpdateRequest'

export default function* signageSaga() {
    yield all([
        watchSignageScreenCreateRequest(),
        watchSignageScreenUpdateRequest()
    ])
}